import React from "react";

const ToggleGroup = ({ label, options, selected, onSelect, formatOption }) => (
    <div className="productdisplay-right-size">
        <h1>{label}</h1>
        <div className="productdisplay-right-sizes">
            {options.map((option) => (
                <div
                    key={option}
                    onClick={() => onSelect(option)}
                    style={{
                        cursor: "pointer",
                        border: option === selected ? "2px solid #f4511e" : undefined,
                        fontWeight: option === selected ? 700 : undefined,
                    }}
                >
                    {formatOption(option)}
                </div>
            ))}
        </div>
    </div>
);

export default ToggleGroup;
